import {type SlackIntegration} from '../../SlackIntegration/utils';
import {type Trigger} from './TriggersTable/utilTypes';

export type NotificationConfig = {
  teamSlackIntegration?: SlackIntegration;
};

// This is used when we have an already created trigger in the UI
export const getSlackNotificationConfig = (
  trigger: Trigger
): NotificationConfig & {entityName?: string} => {
  if (trigger.action?.actionType !== 'NotificationTriggeredAction') {
    return {};
  }
  return {
    teamSlackIntegration: {
      id: trigger.action.spec.integrationID,
      // to pull these we'd need to fetch the integration, they are not used right now
      // TODO: are we sure they're not used? :)
      teamName: '',
      channelName: trigger.action.spec.channelName,
    },
    entityName: trigger.action.spec.entityName,
  };
};
